import React from 'react'
import {FC} from 'react'
import {addDisplayName, addStateHandlers, flowMax} from 'ad-hok'
// import {Visibility, VisibilityOff} from '@material-ui/icons'
// import {IconButton} from '@material-ui/core'

// import InputAdornment from 'components/InputAdornment'
import TextField, {FieldComponentProps} from 'components/TextField'

const PasswordField: FC<FieldComponentProps> = flowMax(
  addDisplayName('PasswordField'),
  addStateHandlers(
    {
      showPassword: false,
    },
    {
      toggleShowPassword: ({showPassword}) => () => ({
        showPassword: !showPassword,
      }),
    }
  ),
  ({showPassword, toggleShowPassword, ...props}) => (
    <TextField
      type={showPassword ? 'text' : 'password'}
      InputProps={
        {
          // endAdornment: (
          //   <InputAdornment position="end">
          //     <IconButton onClick={() => toggleShowPassword()}>
          //       {showPassword ? <Visibility /> : <VisibilityOff />}
          //     </IconButton>
          //   </InputAdornment>
          // ),
        }
      }
      {...props}
    />
  )
)

export default PasswordField
